// @flow

import React from "react";
import {useFormik} from "formik";
import {useObserver} from "mobx-react-lite";
import {useHistory} from "react-router-dom";
import {Input, Form, Modal} from "antd";
import {useTranslation} from "react-i18next";

import {useStore} from "../../../hooks/useStore";
import {fpmPropsType, fpmFormType} from "./fpmPropsTypes";
import {forgotPasswordValidations} from "../loginFormValidations";

export const ForgotPasswordModal = ({isVisible, setVisible}: fpmPropsType) => {
    const {t} = useTranslation(["forgotPasswordModal"]);
    const stores = useStore();
    const history = useHistory();
    const formik = useFormik({
        initialValues: {email: ""},
        validationSchema: forgotPasswordValidations,
        onSubmit: async (values: fpmFormType) => {
            // TODO: url going to be available at mail inbox. this question modal will be removed.
            const result = await stores.meStore.sendResetMail(values);
            if (result) {
                stores.appStore.openSuccessModal({
                    title: t("modal.successfulTitle", {ns: "common"}),
                    content: t("successModalContent", {ns: "forgotPasswordModal"})
                });
            }
            setVisible(false);
        },
        enableReinitialize: false
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setSubmitting
    } = formik;

    return useObserver(() => (
        <React.Fragment>
            <Modal
                data-testid="forgotPassword"
                visible={isVisible}
                centered
                title={t("forgotPasswordModalTitle", {ns: "forgotPasswordModal"})}
                okText={t("modal.sendButton", {ns: "common"})}
                onOk={handleSubmit}
                okButtonProps={{
                    disabled: isSubmitting,
                    "data-testid": "forgotPassword_submitButton"
                }}
                cancelText={t("modal.cancelButton", {ns: "common"})}
                onCancel={() => {
                    resetForm();
                    setVisible();
                }}
                cancelButtonProps={{"data-testid": "forgotPassword_cancelButton"}}
            >
                <Form autoComplete="off" labelCol={{span: 6}} wrapperCol={{span: 18}}>
                    <Form.Item
                        colon={false}
                        label={t("mailInputLabel", {ns: "forgotPasswordModal"})}
                        labelAlign="left"
                        validateStatus={errors.email && touched.email ? "error" : "success"}
                        help={errors.email && touched.email ? errors.email : null}
                    >
                        <Input
                            name="email"
                            data-testid="emailInput"
                            value={values.email}
                            onChange={handleChange}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    ));
};
